"use client";

import React from "react";
import { Button } from "../ui/button";
import { useRouter } from "@/i18n/routing";
import { useTranslations } from "next-intl";
import { env } from "@/lib/env";
import { ChevronLeft } from "lucide-react";

type Props = {
  backUrl: string;
};

const BackButton: React.FC<Props> = ({ backUrl }) => {
  const t = useTranslations("ui");
  const router = useRouter();

  const onBack = () => {
    const canGoBack = window.history.length > 1;

    const mainUrl = env.NEXT_PUBLIC_URL;

    const previousUrl = document.referrer;
    const isPreviousUrl = previousUrl.includes(mainUrl);

    if (canGoBack && isPreviousUrl) {
      router.back();
    } else {
      router.push(backUrl);
    }
  };
  return (
    <Button onClick={onBack} variant="link" size="sm" className="group">
      <ChevronLeft className="h-4 w-4 transition-transform group-hover:-translate-x-1" />
      <span>{t("back")}</span>
    </Button>
  );
};

export default BackButton;
